<template>
  <div class="home-carousel">
    <div class="carousel-main">
      <!-- 轮播区域 -->
      <div class="carousel-wrap">
        <div v-if="hasSlides" class="carousel-slides-wrapper">
          <div class="carousel-slides" :style="{ transform: `translateX(-${activeIndex * 100}%)`, width: `${slides.length * 100}%` }">
            <div v-for="(item, idx) in slides" :key="idx" class="carousel-slide">
              <a :href="getNewsUrl(item.newsCode)" target="_blank">
                <img :src="item.coverImage" :alt="item.title" />
              </a>
              <!-- 底部标题栏 -->
              <div class="slide-info-bar">
                <a :href="getNewsUrl(item.newsCode)" target="_blank" class="slide-title">{{ item.title }}</a>
                <span class="slide-count">{{ idx + 1 }}/{{ slides.length }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="carousel-empty">
          <div class="empty-cover"></div>
        </div>
        <div class="carousel-arrow carousel-arrow-left" @click="prev">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="carousel-arrow carousel-arrow-right" @click="next">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <!-- <div class="carousel-dots">
          <span v-for="(item, idx) in slides" :key="idx" :class="{ active: activeIndex === idx }" @click="activeIndex = idx"></span>
        </div> -->
      </div>
      <!-- 右侧杂志 + 图片 -->
      <div class="carousel-side">
        <IssuePanel />
        <div class="ad-wrap" v-if="sideAd1.imageUrl">
          <a :href="sideAd1.turnUrl || 'javascript:void(0)'" :target="!sideAd2.turnUrl ? '_self' : '_blank'">
            <img class="side-ad" :src="sideAd1.imageUrl" />
            <span v-if="sideAd1.isShowTag === 1" class="ad-tag">广告</span>
          </a>
        </div>
        <div class="ad-wrap" v-if="sideAd2.imageUrl">
          <a :href="sideAd2.turnUrl || 'javascript:void(0)'" :target="!sideAd2.turnUrl ? '_self' : '_blank'">
            <img class="side-ad" :src="sideAd2.imageUrl" />
            <span v-if="sideAd2.isShowTag === 1" class="ad-tag">广告</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IssuePanel from '../../detail/components/IssuePanel.vue'
import { fetchAdDetails, resolveAdImage } from '../../../api'
import request from '../../../api/request'

export default {
  name: 'HomeCarousel',
  components: {
    IssuePanel
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      slides: [],
      sideAd1: {},
      sideAd2: {}
    }
  },
  async created() {
    await this.loadAds()
    await this.loadCarousel()
  },
  mounted() {
    this.startAuto()
  },
  beforeDestroy() {
    this.stopAuto()
  },
  computed: {
    hasSlides() {
      const result = this.slides && this.slides.length > 0
      console.log('[computed] hasSlides:', result, 'slides length:', this.slides?.length)
      return result
    }
  },
  methods: {
    next() {
      if (this.slides.length <= 1) return
      const newIndex = (this.activeIndex + 1) % this.slides.length
      console.log('[HomeCarousel] next(), slides:', this.slides.length, 'from:', this.activeIndex, 'to:', newIndex)
      this.activeIndex = newIndex
    },
    prev() {
      if (this.slides.length <= 1) return
      const newIndex = (this.activeIndex - 1 + this.slides.length) % this.slides.length
      console.log('[HomeCarousel] prev(), slides:', this.slides.length, 'from:', this.activeIndex, 'to:', newIndex)
      this.activeIndex = newIndex
    },
    async loadAds() {
      const [sideList] = await Promise.all([
        fetchAdDetails('index_ezine_btm')
      ])
      console.log('[HomeCarousel] slides loaded:', this.slides.length, 'items')
      this.sideAd1 = sideList[0] || {}
      this.sideAd2 = sideList[1] || {}
      this.sideAd1.imageUrl = resolveAdImage(this.sideAd1.imageUrl)
      this.sideAd2.imageUrl = resolveAdImage(this.sideAd2.imageUrl)
    }, 
    async loadCarousel() {
      const carouselRes = await request.post('/api/index/getIndexRecommendInfo', { positionKey: 'index_carousel' })
      console.log('[HomeCarousel] carouselRes:', carouselRes)
          
      if (carouselRes.code === 200 && carouselRes.data && carouselRes.data.newsList) {
        this.slides = carouselRes.data.newsList.slice(0, 6)
        console.log('[HomeCarousel] slides loaded:', this.slides.length, 'items')
      } else {
        console.warn('[HomeCarousel] No newsList in response:', carouselRes)
        this.slides = []
      }
    },
    // 跳转到新闻详情页
    getNewsUrl(newsCode) {
      return `/zp/a/${encodeURIComponent(newsCode)}`
    },
    startAuto() {
      this.timer = setInterval(() => {
        console.log('[HomeCarousel] auto next, before:', this.activeIndex)
        this.next()
        console.log('[HomeCarousel] auto next, after:', this.activeIndex)
      }, 5000)
    },
    stopAuto() {
      if (this.timer) clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.home-carousel {
  width: 1400px;
  margin: 0 auto;
  background: #f5f5f5;
  padding: 61px 0;
  position: relative;
}
.home-carousel::before,
.home-carousel::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: calc((var(--viewport-width) - 1400px) / 2);
  background: #f5f5f5;
}
.home-carousel::before {
  right: 100%;
}
.home-carousel::after {
  left: 100%;
}
.carousel-main {
  width: 1400px;
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
.carousel-wrap {
  width: 1040px;
  height: 585px;
  position: relative;
  overflow: hidden;
}
.carousel-slides {
  display: flex;
  height: 100%;
}
.carousel-slide {
  min-width: 100%;
  height: 100%;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
}
.carousel-slide a {
  display: block;
  width: 900px;
  height: 100%;
  text-decoration: none;
}
.carousel-slide img {
  width: 1040px;
  height: 585px;
  object-fit: cover;
  display: block;
}
.slide-info-bar {
  position: absolute;
  bottom: 0px;
  left: 0px;  /* (1040 - 900) / 2 = 70 */
  right: 0px;  /* (1040 - 900) / 2 = 70 */
  height: auto;
  min-height: 47px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 0 0 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  width: 1040px;
}
.slide-title {
  height: 24px;
  font-family: 'Microsoft YaHei', 'Microsoft YaHei';
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}
.slide-title:hover {
  color: #cccccc;
  text-decoration: underline;
}
.slide-count {
  min-width: 50px;
  height: 24px;
  text-align: right;
  color: #FFFFFF;
  font-size: 18px;
  font-family: 'Microsoft YaHei', 'Microsoft YaHei';
  line-height: 24px;
  padding-right: 20px;
}
.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(0,0,0,0.3);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
}
.carousel-arrow svg {
  width: 24px;
  height: 24px;
}
.carousel-arrow:hover { background: rgba(0,0,0,0.5); }
.carousel-arrow-left { left: 20px; }
.carousel-arrow-right { right: 20px; }
.carousel-dots {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}
.carousel-dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255,255,255,0.5);
  cursor: pointer;
}
.carousel-dots span.active { background: #fff; }
.carousel-side {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-left: 17px;
  min-height: 585px;
}
/* 强制 IssuePanel 高度 */
.issue-panel-wrapper {
  min-height: 370.5px;
  margin-bottom: 9.5px;
}
.side-ad {
  width: 320px;
  height: 95px;
  object-fit: cover;
  display: block;
}
.ad-wrap {
  position: relative;
  margin-top: -1px;
}
.ad-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 0 4px 0 4px;
  line-height: 1.5;
}
</style>
